import React from 'react'
import container from './container'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Row, Select, Spin } from 'antd'

const SupplierCoverageSearch = props => {
    const { $props, $loading, catalogs } = props
    return (
        <Spin spinning={$loading}>
            <Form colon={false} {...$props}>
                <Card
                    title="Supplier Coverage"
                    size="small"
                    extra={
                        <Button htmlType={'submit'} type="primary">
                            <SearchOutlined /> Find
                        </Button>
                    }>
                    <div className="d-md-flex align-items-center">
                        <Card.Meta description="Hotels that already have an id in one supplier catalog column, with the regions they are mapped to. Check a column like hotelston_id before adding a new supplier to see which test mappings already exist." />
                    </div>
                    <br />
                    <Row gutter={16}>
                        <Col xs={24} md={10}>
                            <Form.Item name={'column'} wrapperCol={{ flex: 1 }}>
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Supplier catalog column, e.g. hotelston_id">
                                    {catalogs.map(catalog => (
                                        <Select.Option value={catalog.column} key={catalog.column}>
                                            {catalog.codes && catalog.codes.length
                                                ? `${catalog.column} — ${catalog.codes.join(', ')}`
                                                : catalog.column}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Form>
        </Spin>
    )
}

export default container(SupplierCoverageSearch)
